var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-heading" }, [
    _c("div", { staticClass: "main-heading__title" }, [
      _c("span", { staticClass: "glicon-user-thin" }),
      _c("span", [_vm._v(_vm._s(_vm.$t("pageTitles.account")))]),
      !_vm.$route.meta.hideBreadcrumb
        ? _c(
            "ul",
            { staticClass: "breadcrumb-platform" },
            _vm._l(_vm.$route.matched, function(route, index) {
              return _c(
                "li",
                { key: index, staticClass: "breadcrumb-platform__item" },
                [
                  route.meta.adminName && _vm.admin
                    ? _c(
                        "router-link",
                        { attrs: { to: { name: route.name } } },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                (_vm.admin.name
                                  ? _vm.admin.name
                                  : _vm.admin.email) +
                                  " " +
                                  (_vm.admin.surname || "")
                              ) +
                              " "
                          )
                        ]
                      )
                    : _c(
                        "router-link",
                        { attrs: { to: { name: route.name } } },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t(`breadcrumb.${route.meta.title}`)) +
                              " "
                          )
                        ]
                      ),
                  _c("span", { staticClass: "glicon-double" })
                ],
                1
              )
            }),
            0
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }